import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ClinicStatus } from '../../models/clinic-status.model';
import { ClinicStatusService } from '../../services/clinic-status.service';

@Component({
  selector: 'app-clinic-status',
  templateUrl: './clinic-status.component.html',
  styleUrls: ['./clinic-status.component.css']
})
export class ClinicStatusComponent implements OnInit {

  clinicStatus: ClinicStatus;

  constructor(private route: ActivatedRoute, private clinicStatusService: ClinicStatusService) { }

  ngOnInit() {
    const id = Number(this.route.snapshot.paramMap.get("id"));

    this.clinicStatusService.getClinicStatus(id).subscribe(status => {
      this.clinicStatus = status;
    });
  }
}
